<div class="main" data-cy="organizer-rename-container">
  <div class="standard-dialog-header" data-cy="organizer-rename-header">{{title}}</div>
  <div class="standard-dialog-content" style="display: flex; flex-direction: column;" data-cy="organizer-rename-content">
    <div style="flex: 1; text-align: center; margin-top: 10px;" data-cy="organizer-rename-input-container">
      <input placeholder="Change title" [(ngModel)]="input" style="width: 80%; margin-right: auto; margin-left: auto;" data-cy="organizer-rename-input">
    </div>
    <div style="display: flex; flex-basis: fit-content; width: fit-content; margin-left: auto; margin-right: 2px;" data-cy="organizer-rename-actions">
      <button [disabled]="!isChanged" (click)="onApply()" class="tdo-button primary" style="margin-right: 6px;" data-cy="organizer-rename-ok-button">
        Ok
      </button>
      <div (click)="onCancel()" class="tdo-button warn" style="margin-left: 4px;" data-cy="organizer-rename-cancel-button">
        Cancel
      </div>
    </div>
  </div>
</div>
